import React from 'react';
import Chart from 'react-apexcharts';

class WidgetPieChart extends React.Component {

  render() {
    const table = this.props.table;
    const options = {
      title: {
        text: this.props.name,
        align: 'middle'
      },
      labels: [],
      chart: {
        events: {
          dataPointSelection: (_, __, config) => {
            console.log(config.dataPointIndex);
            console.log(config.w.config.labels[config.dataPointIndex]);
          }
        }
      },
      dataLabels: {
        formatter: (val, opt) => table[opt.seriesIndex + 1][0] + ":  " + table[opt.seriesIndex + 1][1]
      }
    };
    const series = [];

    for(let i = 1; i < table.length - 1; i++) {
      options.labels.push(table[i][0]);
      series.push(table[i][1]);
    }
    
    return(
      <div className={`col-md-${this.props.report ? 12 : 4}`}>
        <Chart options={options} series={series} type="donut" height={320} />
      </div>
    );
  }
}
export default WidgetPieChart;